<template>
  <div>
    <div class="bg-white mx-auto mt-8" style="width: 920px">
      <div class="flex justify-between">
        <div
          v-if="
            state._estimateData.est_drafted_numbers &&
            state._estimateData.est_drafted_numbers.length > 1
          "
          class="text-gray-92 text-xl"
        >
          {{ state.estDraftedNumber }}/{{
            state._estimateData.est_drafted_numbers.length
          }}
          <span class="text-base">件</span>
        </div>
      </div>
      <div
        class="flex items-center justify-center text-center font-semibold h-10 mt-8 mb-8"
        style="color: #2cb2b2; background: rgba(73, 168, 174, 0.1)"
      >
        この内容で送信してよろしいですか？
      </div>
      <div class="flex justify-between">
        <div style="color: #344464">
          {{ state._estimateData.buyer_company_name }}
        </div>
        <div class="font-semibold text-gray-92">
          No : {{ state._estimateData.transaction_service_id }} -
          {{ state._estimateData.pattern_number }}
        </div>
      </div>
      <div style="color: #344464">{{ state._estimateData.buyer_name }}様</div>
      <div class="text-xl font-semibold leading-8 pt-2">
        {{ state._estimateData.service_category_name }}
      </div>
      <div
        class="text-2xl font-semibold leading-8 pt-2"
        style="margin-bottom: 36px"
      >
        {{ state._estimateData.title }}
      </div>
      <div class="text-gray-92">下記の通りお見積り申し上げます。</div>

      <div class="flex justify-between items-end">
        <div>
          <span class="text-gray-92 text-base font-semibold">お見積り金額</span>
          <span class="ml-1 text-2xl font-semibold" style="color: #344464">{{
            amountFormatter(state._estimateData.total_with_tax)
          }}</span>
          <span class="ml-1 text-gray-92 font-semibold">円（税込）</span>
        </div>
        <div class="text-right text-gray-92">
          <div>{{ state.estimateDate }}</div>
          <div class="font-semibold">
            {{ state._estimateData.seller_company_name }}
          </div>
          <div class="font-semibold">{{ state._estimateData.seller_name }}</div>
        </div>
      </div>

      <section class="mt-12">
        <table class="w-full table-fixed divide-y divide-gray-12">
          <thead>
            <tr class="text-gray-62 font-semibold leading-4 h-10">
              <td
                class="text-center h-10 sticky top-0 z-10"
                :class="{ is_sticky: state.onScroll }"
                style="width: 315px"
              >
                項目
              </td>
              <td
                class="text-center h-10 sticky top-0 z-10"
                :class="{ is_sticky: state.onScroll }"
                style="width: 192px"
              >
                数量
              </td>
              <td
                class="text-center h-10 sticky top-0 z-10"
                :class="{ is_sticky: state.onScroll }"
                style="width: 155px"
              >
                単価（円）
              </td>
              <td
                class="text-center h-10 sticky top-0 z-10"
                :class="{ is_sticky: state.onScroll }"
                style="width: 135px"
              >
                期間
              </td>
              <td
                class="text-right pr-2 h-10 sticky top-0 z-10"
                :class="{ is_sticky: state.onScroll }"
                style="width: 122px"
              >
                小計（税抜）
              </td>
            </tr>
          </thead>

          <tbody
            v-for="(sectionItem, index) in state._estimateData.section_items"
            :key="index"
          >
            <tr class="bg-slate-300 h-12">
              <td class="pl-4 text-gray-92 font-semibold" colspan="4">
                {{ sectionItem.name }}
              </td>
              <td class="pr-4 text-right text-base text-gray-92 font-semibold">
                {{ amountFormatter(sectionItem.amount) }}
              </td>
            </tr>
            <tr
              v-for="(detailItem, idx) in sectionItem.detail_items"
              :key="idx"
              :id="detailItem.id"
              class="border-b border-gray-12"
              style="height: 56px"
            >
              <td class="text-gray-92 p-4" style="width: 312px">
                {{ detailItem.name }}
              </td>
              <td
                class="text-base text-center text-gray-92"
                style="width: 192px"
              >
                <div class="inline-flex">{{ detailItem.quantity }}</div>
                <span class="text-xs">{{ detailItem.quantity_unit_name }}</span>
              </td>
              <td
                class="text-base text-right text-gray-92 pr-12"
                style="width: 155px; height: 56px"
              >
                {{ amountFormatter(detailItem.price) }}
              </td>
              <td
                class="text-base text-center text-gray-92"
                style="width: 135px; height: 56px"
              >
                <span v-if="detailItem.term">{{ detailItem.term }}</span>
                <span v-if="detailItem.term" class="text-xs">{{
                  detailItem.term_unit_name
                }}</span>
                <span v-else class="text-xs">ー</span>
              </td>
              <td
                class="text-base text-right text-gray-92 pr-4"
                style="width: 122px"
              >
                {{ amountFormatter(detailItem.amount) }}
              </td>
            </tr>
            <tr v-if="sectionItem.note">
              <td
                class="text-xs text-gray-92 p-4 pb-8 whitespace-pre-wrap"
                colspan="5"
              >
                {{ sectionItem.note }}
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div
        class="flex flex-col divide-y divide-gray-12 ml-auto"
        style="width: 400px; padding-bottom: 33px"
      >
        <div class="flex flex-row px-2 py-3 justify-between leading-8">
          <div class="text-gray-92 font-semibold">小計（税別）</div>
          <div>
            <span
              v-if="state._estimateData.total"
              class="text-lg"
              style="color: #344464"
              >{{ amountFormatter(state._estimateData.total) }}</span
            >
            <span class="ml-1 leadning-4 text-gray-92 text-xs">円</span>
          </div>
        </div>
        <div class="flex flex-row px-2 py-3 justify-between leading-8">
          <div class="text-gray-92 font-semibold">
            消費税（{{ state._estimateData.tax_rate }}%)
          </div>
          <div>
            <span class="text-lg" style="color: #344464">{{
              amountFormatter(state._estimateData.tax)
            }}</span>
            <span class="ml-1 text-gray-92 text-xs">円</span>
          </div>
        </div>
        <div class="flex flex-row px-2 py-3 justify-between leading-8">
          <div class="text-gray-92 font-semibold">合計（税込）</div>
          <div>
            <span class="text-2xl font-semibold" style="color: #344464">{{
              amountFormatter(state._estimateData.total_with_tax)
            }}</span>
            <span class="ml-1 leadning-4 text-gray-92 text-sm">円</span>
          </div>
        </div>
        <span class="text-xs text-gray-92 text-right pt-6"
          >※一括見積もりの概算であり、金額を確定するものではありません。</span
        >
      </div>

      <div
        v-if="
          state._estimateData.questions &&
          state._estimateData.questions.length > 0
        "
        class="border-t border-gray-12 mt-2 mb-10"
      >
        <div class="text-gray-62 font-semibold mt-8 mb-3">質問リスト</div>
        <div
          v-for="question in state._estimateData.questions"
          :key="question.id"
          class="border-b border-gray-12 mb-6"
        >
          <div class="flex mb-3">
            <div
              style="min-width: 20px; height: 20px"
              class="flex items-center justify-center rounded-full bg-slate-300"
            >
              <img src="@/assets/icons/AlphabetQ.svg" />
            </div>
            <div class="ml-3 font-semibold whitespace-pre-wrap">
              {{ question.name }}
            </div>
          </div>
          <div class="flex mb-4">
            <div
              style="
                min-width: 20px;
                height: 20px;
                background-color: rgba(108, 126, 206, 0.1);
              "
              class="flex items-center justify-center rounded-full mt-1"
            >
              <img src="@/assets/icons/AlphabetA.svg" />
            </div>
            <div class="ml-3 leading-6 whitespace-pre-wrap">
              {{ question.value }}
            </div>
          </div>
        </div>
      </div>

      <div class="mb-10">
        <div class="pb-1 text-gray-92">メッセージ</div>
        <div
          class="text-gray-92 leading-6 whitespace-pre-line pb-1 border-b border-gray-12"
        >
          {{ state._estimateData.message }}
        </div>
        <div class="pt-2 text-right">
          <div
            v-for="(file, index) in state._estimateData.files"
            :key="index"
            class="flex justify-end m-2 ml-auto"
          >
            <img
              style="width: 18px; height: 18px; margin-top: 2px"
              src="@/assets/icons/Clip.svg"
            />
            <a
              v-if="file.id && file.url"
              target="_blank"
              :href="file.url"
              class="ml-2 text-coral-main"
            >
              {{ file.name }}
            </a>
            <div v-else class="ml-2 text-coral-main">{{ file.name }}</div>
          </div>
        </div>
      </div>
      <div
        v-if="
          state._estimateData.est_drafted_numbers &&
          state._estimateData.est_drafted_numbers.length > 1
        "
        class="mb-20 pb-2 border-b border-gray-12"
      >
        <div class="mb-1 text-gray-92">他の下書き見積もりを確認する</div>
        <span
          v-for="number in state._estimateData.est_drafted_numbers"
          :key="number"
          class="p-1 cursor-pointer underline hover:button"
          @click="redirectPatternNumber(number)"
        >
          <span v-if="patternNumber != number"
            >No : {{ state._estimateData.transaction_service_id }} -
            {{ number }}</span
          >
        </span>
      </div>
    </div>

    <div
      class="bg-white"
      style="box-shadow: 0px 0px 8px rgba(152, 163, 190, 0.3); z-index: 20"
    >
      <div class="flex justify-between h-16 mx-auto" style="width: 1000px">
        <div class="flex items-center h-16 ml-10 text-gray-92">
          <span @click="toEstimateInput()" class="cursor-pointer"
            >内容を訂正</span
          >
        </div>
        <div class="flex">
          <button
            v-if="
              state._estimateData.is_continue_enable &&
              state._estimateData.est_drafted_numbers
            "
            class="text-coral-main font-semibold mr-6 hover:button focus:outline-none"
            @click="continueEstimate()"
          >
            続けて{{
              state._estimateData.est_drafted_numbers.length + 1
            }}件目の見積もりを作成する
          </button>
          <button
            v-if="
              state._estimateData.est_drafted_numbers &&
              state._estimateData.est_drafted_numbers.length <= 1
            "
            class="flex items-center justify-center bg-coral-main text-base text-white font-semibold hover:button focus:outline-none"
            style="width: 240px"
            @click="
              state.isSubmitted = true;
              onSubmit();
            "
            :disabled="state.isSubmitted"
          >
            この内容で送信
          </button>
          <button
            v-else-if="state._estimateData.est_drafted_numbers"
            class="flex items-center justify-center bg-coral-main text-base text-white font-semibold hover:button focus:outline-none"
            style="width: 280px"
            @click="onSubmit()"
          >
            この内容で{{
              state._estimateData.est_drafted_numbers.length
            }}件まとめて送信
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, computed, inject } from 'vue';
import { useRouter } from 'vue-router';
import { amountFormatter } from '@/utils/filters.js';
import axios from '@/utils/axiosAuth.js';

export default {
  props: {
    transactionId: String,
    patternNumber: String,
    estimateData: Object,
  },
  setup(props) {
    const globalMethods = inject('globalMethods');
    const router = useRouter();

    const state = reactive({
      isSubmitted: false,
      onScroll: false,
      _estimateData: computed(() => {
        return props.estimateData;
      }),
      estDraftedNumber: computed(() => {
        return (
          state._estimateData.est_drafted_numbers.findIndex(
            (e) => e == props.patternNumber
          ) + 1
        );
      }),
      estimateDate: computed(() => {
        return (
          new Date().getFullYear() +
          '年' +
          (new Date().getMonth() + 1) +
          '月' +
          new Date().getDate() +
          '日'
        );
      }),
    });

    function toEstimateInput() {
      router.push({
        name: 'EstimateInput',
        params: { transactionId: props.transactionId },
      });
      window.scrollTo(0, 0);
    }

    function redirectPatternNumber(number) {
      // router.push({
      //   name: 'EstimateConfirm',
      //   params: { transactionId: props.transactionId, patternNumber: number },
      // });
      location.href = `${location.protocol}//${location.hostname}/estimate/${props.transactionId}/${number}/confirm/`;
    }

    function makePostData() {
      let postData = {
        title: state._estimateData.title,
        section_items: [],
        message: state._estimateData.message,
        files: [],
        questions: [],
      };

      for (let i = 0; i < state._estimateData.section_items.length; i++) {
        let obj = {
          detail_items: [],
          value_id: state._estimateData.section_items[i].value_id,
          id: state._estimateData.section_items[i].id,
          note: state._estimateData.section_items[i].note,
        };
        obj.value_id = state._estimateData.section_items[i].value_id;
        obj.id = state._estimateData.section_items[i].id;
        obj.note = state._estimateData.section_items[i].note;

        for (
          let s = 0;
          s < state._estimateData.section_items[i].detail_items.length;
          s++
        ) {
          if (
            state._estimateData.section_items[i].detail_items[s].name &&
            state._estimateData.section_items[i].detail_items[s].price &&
            state._estimateData.section_items[i].detail_items[s].quantity
          ) {
            obj.detail_items.push(
              state._estimateData.section_items[i].detail_items[s]
            );
          }
        }
        postData.section_items.push(obj);
      }

      // 添付ファイル
      for (const file of state._estimateData.files) {
        postData.files.push(file);
      }

      // 質問リスト
      for (const question of state._estimateData.questions) {
        postData.questions.push(question);
      }

      return postData;
    }

    async function onSubmit() {
      const postData = makePostData();

      if (state._estimateData.is_continue_enable) {
        await axios
          .post(`transactions/${props.transactionId}/est/publish`, postData)
          .then(() => {
            router.push({ name: 'EstimateCompleted' });
            window.scrollTo(0, 0);
          })
          .catch((e) => {
            globalMethods.updateModal(
              true,
              'リクエストが完了しませんでした。',
              e.systemMessage || '',
              e.callback
            );
            globalMethods.sendLog(e);
          });
      } else {
        //修正見積もりの場合はpatternNumberを加えてpostする。
        await axios
          .post(
            `transactions/${props.transactionId}/est/publish/${props.patternNumber}`,
            postData
          )
          .then(() => {
            router.push({ name: 'EstimateCompleted' });
            window.scrollTo(0, 0);
          })
          .catch((e) => {
            globalMethods.updateModal(
              true,
              'リクエストが完了しませんでした。',
              e.systemMessage || '',
              e.callback
            );
            globalMethods.sendLog(e);
          });
      }
    }

    async function continueEstimate() {
      await axios
        .get(`transactions/${props.transactionId}/est/pattern-number/continue`)
        .then((response) => {
          // router.push({
          //   name: 'EstimateInput',
          //   params: {
          //     transactionId: props.transactionId,
          //     patternNumber: response.data.data.pattern_number,
          //   },
          // });
          location.href = `${location.protocol}//${location.hostname}/estimate/${props.transactionId}/${response.data.data.pattern_number}/`;
        })
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'エラーが発生しました。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        });
    }

    window.addEventListener('scroll', function () {
      if (window.scrollY >= 480) {
        state.onScroll = true;
      } else if (window.scrollY < 480) {
        state.onScroll = false;
      }
    });

    return {
      state,
      toEstimateInput,
      redirectPatternNumber,
      onSubmit,
      continueEstimate,
      amountFormatter,
    };
  },
};
</script>

<style lang="scss" scoped>
.is_sticky {
  box-sizing: border-box;
  @apply text-gray-92 border-b border-gray-12;
  background: #f1f2f6;
}
</style>
